import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { columnName, columnValidTo } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { deleteToken, hideDeleteToken } from '../actions';
import TokensTableColumns from './TokensTableColumns';
import TokensTableRows from './TokensTableRows';

const TokenDeletionDialog = ({
  category,
  deleteData,
  hide,
  results,
  theme,
}) => (
  <ActionDialogContent
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    items={results}
    hide={hide}
    theme={theme}
    onSubmit={({ items }) => deleteData(items, category)}
    entity="token"
    entities="tokens"
    className="aridhia-token-deletion-dialog"
    icon="code"
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-Tokens-table sticky-header">
        <Table.Header>
          <TokensTableColumns items={results} columns={[columnName, columnValidTo]} />
        </Table.Header>
        <Table.Body>
          <TokensTableRows items={results} columns={[columnName, columnValidTo]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ActionDialogContent>
);

const mapStateToProps = ({
  tokens: { tokens: { batch: { results } }, deleteTokenCategory },
}) => ({
  category: deleteTokenCategory,
  results,
});

const mapDispatchToProps = {
  hide: hideDeleteToken,
  deleteData: deleteToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenDeletionDialog);
